import * as fromReactionsGraph from '../reducers/reactions-graph.reducer'
import { createFeatureSelector, createSelector } from '@ngrx/store'
import { getCriteriaFrom, getCriteriaTo } from './criteria.selector'
import * as moment from 'moment'

export const getReactionsGraph = createFeatureSelector<fromReactionsGraph.State>('reactionsGraph')

export const getReactions = createSelector(
  getReactionsGraph,
  state => state.reactions
)

export const getLoading = createSelector(
  getReactionsGraph,
  state => state.loading
)

export const getLoaded = createSelector(
  getReactionsGraph,
  state => state.loaded
)

export const getReactionsCsv = createSelector(
  getReactionsGraph,
  getCriteriaFrom,
  getCriteriaTo,
  (state, from, to) => {
    const data = []
    data.push([
      '集計期間',
      moment(from).format('YYYY-MM-DD') + ' ~ ' + moment(to).format('YYYY-MM-DD'),
    ])
    data.push([])
    data.push(['日付'].concat([...new Set(state.reactions.map(item => item.sourceName))]))
    const charts = convert2ChartData(state.reactions)
    charts.map(item => data.push(item))
    return data
  }
)

function convert2ChartData(obj: any[]): any[] {
  const dates = [...new Set(obj.map(item => item.transactionDate))]
  const column = []
  dates.forEach(d => {
    const data: any[] = [d]
    column.push(data)
    obj.map(units => {
      if (d === units.transactionDate) {
        data.push(units.units)
      }
    })
  })
  return column
}
